import { createContext } from 'react';
import { QuizController } from './types';

// eslint-disable-next-line
export const QuizContext = createContext<QuizController | null>(null);

export type QuizProviderProps = {
  controller: QuizController;
};

export function QuizProvider({
  controller,
  ...others
}: React.PropsWithChildren<QuizProviderProps>) {
  return <QuizContext.Provider {...others} value={controller} />;
}

QuizProvider.displayName = 'QuizProvider';
